import { Hero } from "../components/Hero";
import { About } from "../components/About";

export const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
    </>
  );
};
